<template>
  <div
    id="organisation-panel"
    class="no-shrink">
    <div class="to-desktop-handle no-shrink browser-navigation">
      <!-- We will not use navigation buttons for now -->
      <!-- <SBIcon
        class="mr-1 history-back-button"
        :icon="SBIconList.DOWN_ARROW"
        :color="SBColors.greyPrimary"
        :hover-icon-color="SBColors.blackUltralight"
        :hover-size="24"
        :border-radius="50"
        :rotate="90"
        :pointer="true"
        :size="12"/>
      <SBIcon
        class="mr-1 history-forward-button"
        :icon="SBIconList.DOWN_ARROW"
        :color="SBColors.greyPrimary"
        :hover-icon-color="SBColors.blackUltralight"
        :hover-size="24"
        :border-radius="50"
        :rotate="270"
        pointer
        :size="12"/> -->
    </div>
    <div
      class="item-wrapper flex flex-align-center space-between">
      <SelectOrganisation :class="{ 'top-layer': !ignoreActivation && (activateOrganisation || isPermissionDenied) }"/>
      <SelectMember :class="{ 'top-layer': !ignoreActivation && (activateOrganisation || isPermissionDenied) }"/>
    </div>

    <b-button
      v-if="!isPermissionDenied"
      id="new-message"
      class="flex flex-align-center"
      @click="startNewConversation" >
      <SBIcon
        :icon="SBIconList.NEW_MESSAGE"
        :color="SBColors.blackPrimary"
        :size="14" />
      <p>New message</p>
    </b-button>

    <!-- <b-button
      class="flex flex-align-center mx-3"
      @click="test" >
      <p>Test</p>
    </b-button> -->

    <b-popover
      ref="branchFilterPopover"
      target="new-message"
      triggers="manual"
      placement="bottomright"
      custom-class="interactive-popover organisation-panel-popover new-message-popover hide-arrow"
      @show="startBranchSelect"
      @hide="endBranchSelect" >
      <SelectBranch
        v-click-outside="closePopover"
        title="Send from"
        only-available
        @branch-selected="startNewConversationForBranch" />
    </b-popover>

    <!-- <UserProfile /> -->

    <ScrollArea
      v-if="!isPermissionDenied">
      <div class="groups-wrap">
        <!-- Progress actions  -->
        <div
          v-if="Object.values(progressActions).length"
          class="group" >
          <ProgressMonitor
            v-for="(action) in Object.values(progressActions).sort((a, b) => b.startDate - a.startDate)"
            :key="action.id"
            :data="action" />
        </div>

        <div class="group">
          <template v-if="hasFlowsEnabled">
            <router-link
              class="panel-item"
              :to="{ name: 'FlowTestMain', params: { organisationId: orgToLoad } }"
              exact-path >
              <span class="icon-wrap">
                <span class="custom-icon panel-flows" />
              </span>
              <span class="title">AI</span>
            </router-link>
            <b-collapse
              :visible="RegExp('\/flows', 'i').test($route.path) || RegExp('\/AI/assistants', 'i').test($route.path)"
              class="indent" >
              <router-link
                class="panel-item"
                :class="{'forced-match': RegExp('\/AI/assistants', 'i').test($route.path)}"
                :to="{ name: 'AIAssistants', params: { organisationId: orgToLoad } }" >
                <span class="title">Assistants</span>
              </router-link>
              <router-link
                class="panel-item"
                :class="{'forced-match': RegExp('\/flows/list', 'i').test($route.path)}"
                :to="{ name: 'AIFlows', params: { organisationId: orgToLoad } }" >
                <span class="title">Flows</span>
              </router-link>
            </b-collapse>
          </template>

          <router-link
            class="panel-item"
            :to="{ name: 'OrgContacts', params: { organisationId: orgToLoad } }"
            exact-path >
            <span class="icon-wrap">
              <span class="custom-icon panel-contacts" />
            </span>
            <span class="title">Contacts</span>
          </router-link>
          <router-link
            class="panel-item"
            :class="{'forced-match': RegExp('\/analytics', 'i').test($route.path)}"
            :to="{ name: 'OrgAnalytics', params: { organisationId: orgToLoad } }"
            exact >
            <span class="icon-wrap">
              <span class="custom-icon panel-analytics" />
            </span>
            <span class="title">Activity</span>
          </router-link>
          <router-link
            v-if="userSettingsAccess"
            class="panel-item"
            :class="{'forced-match': RegExp('\/settings', 'i').test($route.path)}"
            :to="{ name: 'OrgSettings', params: { organisationId: orgToLoad, numberId: branches[0] ? branches[0].id : '' } }"
            exact >
            <span class="icon-wrap">
              <span class="custom-icon panel-settings" />
            </span>
            <span class="title">Settings</span>
          </router-link>
        </div>

        <!-- next group -->
        <div
          v-if="organisationMembers && organisationMembers.length > 1"
          class="group">
          <div
            class="panel-item header">
            <span class="icon-wrap">
              <SBIcon
                :icon="SBIconList.PANEL_ME"
                :color="SBColors.blackUltralight"
                :size="16"/>
            </span>
            <span class="title">Me</span>
          </div>
          <router-link
            class="panel-item only-exact"
            :class="{'hide-active': chatSearchAllNumbersSelected, 'forced-match': RegExp(/\/org\/[\w\-]+?\/my\//, 'i').test($route.path)}"
            :to="{ name: 'OrganisationWithId', params: { organisationId: orgToLoad } }"
            @click.native="resetIfNeeded" >
            <span class="icon-wrap">
              <span class="custom-icon panel-conversations" />
            </span>
            <span
              class="title greedy"
              :class="{'scroll-marker': all_assigned_unread2}" >My chats</span>
            <span
              v-if="all_assigned_unread2"
              class="count-unread ml-2 mr-2 flex center-all" >{{ all_assigned_unread2 }}</span>
          </router-link>
        </div>
        <!-- next group -->
        <div class="group">
          <div
            class="panel-item header">
            <span class="icon-wrap">
              <SBIcon
                :icon="SBIconList.PANEL_PHONE"
                :color="SBColors.blackUltralight"
                :size="16"/>
            </span>
            <span class="title">Phone numbers</span>
          </div>
          <!-- :lock="numberMembers && numberMembers[branch.id] && numberMembers[branch.id].length === 1" -->
          <BranchInfo
            v-for="(branch, index) in branches"
            :key="branch.id"
            :organisation-id="organisationId"
            :branch="branch"
            :active="!['OrganisationConversation', 'OrganisationWithId'].includes($route.name) && branch.id === businessId && !chatSearchAllNumbersSelected"
            :icon-index="index" />
        </div>

        <!-- TODO return to 3 - this is just for testing -->
        <!-- <div
        v-if="currentOrganisationMembers.length < 3333"
        class="group">
        <div
          class="add-team-section"
          @click="openAddMemberModal">
          <span class="icon-wrap">
            <span class="custom-icon" />
          </span>
          <span class="title">Invite your team</span>
        </div>
      </div> -->

        <!-- <div class="group">
          <div
            class="add-team-section"
            @click="openAddNumberModal">
            <span class="icon-wrap">
              <span class="custom-icon" />
            </span>
            <span class="title">Add a phone number</span>
          </div>
        </div> -->

        <div class="group">
          <a
            :href="addPhoneLinkWithParams"
            target="_blank" >
            <div
              class="add-team-section">
              <span class="icon-wrap">
                <span class="custom-icon" />
              </span>
              <span class="title">Add a phone number</span>
            </div>
          </a>
        </div>

      </div>
    </ScrollArea>

    <!-- Enable AI banner -->
    <a
      v-if="!hasFlowsEnabled"
      class="flex center-all banner-app-btn enable-flows"
      :href="linkWithParams"
      target="_blank"
      download >
      <span class="icon-wrap mr-2">
        <span class="custom-icon panel-flows" />
      </span>
      <p>Automate chats with AI</p>
    </a>

    <!-- Download desktop banner -->
    <a
      v-if="!isToDesktopApp && platform && !isPermissionDenied"
      id="download-desktop-app-btn"
      class="flex center-all"
      href="https://dl.todesktop.com/230707w50tgf6o8/"
      download >
      <SBIcon
        class="mr-2"
        :icon="SBIconList.APP_DOWNLOAD_DESKTOP"
        :color="SBColors.blackLight"
        :hover-icon-color="SBColors.blackPrimary"
        :pointer="true"
        :size="20"/>
      <p>Try Number™ for {{ platform }}</p>
    </a>

    <InviteTeamMembersModal
      ref="inviteTeamMemberModalRef" />

    <AddNumberModal ref="addNumberModal" />
  </div>
</template>

<script>
import platform from 'platform-detect';
import { app } from '@todesktop/client-core';
import { isDesktopApp } from '@todesktop/client-core/platform/todesktop';

import SBColors from '@/helpers/lists/colors';
import SBIcon from '@/components/common/Icon';
import SBIconList from '@/helpers/lists/sb-icon-list';
import { mapActions, mapGetters } from 'vuex';
import UserProfile from './panel/UserProfile';
import BranchInfo from './panel/BranchInfo';
import InviteTeamMembersModal from '@/components/business/settings/modals/InviteTeamMembers.modal';
import AddNumberModal from '@/components/business/settings/modals/AddNumber.modal';
import UserPermissionsMixin from '@/mixins/UserPermissions.mixin';
import { getLastOrgId, saveLastOrgId } from '@/helpers/localStorage.helpers';
import ScrollArea from '@/components/common/ScrollArea';
import SelectOrganisation from '@/components/organisation/SelectOrganisation';
import SelectMember from '@/components/member/SelectMember';
import SelectBranch from '@/components/business/branch/SelectBranch';
import ProgressMonitor from './ProgressMonitor';

export default {
  name: 'OrganisationPanel',
  components: {
    UserProfile,
    BranchInfo,
    SBIcon,
    InviteTeamMembersModal,
    AddNumberModal,
    ScrollArea,
    SelectOrganisation,
    SelectMember,
    SelectBranch,
    ProgressMonitor,
  },
  mixins: [
    UserPermissionsMixin,
  ],
  props: {
    organisationId: {
      type: String,
      required: false,
      default: '',
    },
    businessId: {
      type: String,
      required: false,
      default: '',
    },
    conversationId: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      filterBranchPopoverVisible: false,
      SBIconList,
      SBColors,
    };
  },
  computed: {
    ...mapGetters({
      currentOrganisation: 'organisation/currentOrganisation',
      chatSearchAllNumbersSelected: 'chat/chatSearchAllNumbersSelected',
      currentOrganisationMembers: 'organisation/currentOrganisationMembers',
      statistics: 'organisation/statistics',
      localStatsOffsetMyChatCount: 'organisation/localStatsOffsetMyChatCount',
      me: 'organisation/me',
      incognito: 'user/incognito',
      numberMembers: 'organisation/numberMembers',
      organisationMembers: 'organisation/currentOrganisationMembers',
      progressActions: 'organisation/progressActions',
      permissionDenied: 'user/permissionDenied',
      organisationFeatures: 'organisation/features',
      unreadCounter: 'chat/unreadCounter',
    }),
    hasFlowsEnabled() {
      let orgFlows;
      if (this.emptyObject(this.organisationFeatures)) return false;
      try {
        orgFlows = this.organisationFeatures.organisation_features.FLOWS.find(f => f.code === 'FLOWS');
      } catch (e) {
        orgFlows = {};
      }
      return orgFlows && orgFlows.feature_active;
    },
    addPhoneLinkWithParams() {
      return `https://tally.so/r/wgA5KO?email=${this.me.email}&name=${this.currentOrganisation.name}`;
    },
    activateOrganisation() {
      return this.currentOrganisation && (this.currentOrganisation.should_activate_account || this.currentOrganisation.should_reactivate_account);
    },
    ignoreActivation() {
      return !!(this.incognito || (this.$route && this.$route.meta && this.$route.meta.ignoreActivation));
    },
    numberId() {
      return this.$route.params.businessId;
    },
    branches() {
      return this.currentOrganisation.businesses;
    },
    orgToLoad() {
      return this.organisationId || getLastOrgId();
    },
    all_assigned_unread() {
      let counter = 0;
      const bussinessesFromStatistics = Object.keys(this.statistics);
      bussinessesFromStatistics.forEach((bussiness) => {
        counter += this.statistics[bussiness] && this.statistics[bussiness].open && this.statistics[bussiness].open.user_unread && this.statistics[bussiness].open.user_unread[this.me.id] && parseInt(this.statistics[bussiness].open.user_unread[this.me.id], 10) ? parseInt(this.statistics[bussiness].open.user_unread[this.me.id], 10) : 0;
        if (this.localStatsOffsetMyChatCount[bussiness] && parseInt(this.localStatsOffsetMyChatCount[bussiness], 10)) {
          counter += this.localStatsOffsetMyChatCount[bussiness];
        }
      });
      return counter < 0 ? 0 : counter;
    },
    all_assigned_unread2() {
      let counter = 0;
      try {
        counter = Object.values(this.unreadCounter).reduce(
          (sum, numberCounter) => sum + numberCounter.userCounter,
          0,
        );
      } catch (error) { /* do nothing */ }
      return counter;
    },
    isPermissionDenied() {
      return this.permissionDenied.message === 'Unauthorized IP - Access Denied';
    },
    isToDesktopApp() {
      return window.todesktop;
    },
    linkWithParams() {
      return `https://tally.so/r/mOPzO8?email=${this.me.email}&name=${this.currentOrganisation.name}`;
    },
    platform() {
      let os = false;
      if (platform.windows) {
        os = 'Windows';
      } else if (platform.linux) {
        os = 'Linux';
      } else if (platform.macos) {
        os = 'Mac';
      }
      return os;
    },
  },
  watch: {
    all_assigned_unread() {
      // this.$eventBus.$emit('update-unread-count', this.all_assigned_unread);
      // this.setUnreadCounter(this.$options.filters.nineNinePlus(this.all_assigned_unread));
      // if (isDesktopApp()) {
      //   app.setBadgeCount(this.$options.filters.nineNinePlus(this.all_assigned_unread));
      // }
    },
    businessId(newBusinessId, oldBusinessId) {
      this.saveToLocalstorage('lastBusinessInFocus', this.businessId);
      this.fetchOrganisationNumberStatistics({
        organisationId: this.currentOrganisation.id,
        businessId: this.numberId,
        forceStatistics: true,
        data: {
          sections: 'all_unread,user_unread',
        },
      });
    },
    conversationId() {
      this.saveToLocalstorage('lastConversationInFocus', this.conversationId);
    },
    currentOrganisation() {
      // localStorage.setItem('lastOrgSelected', this.currentOrganisation.id);
      saveLastOrgId();
      this.clearStatisticLocalData();
    },
  },
  created() {},
  mounted() {
    saveLastOrgId();
  },
  methods: {
    ...mapActions({
      fetchOrganisationNumberStatistics: 'organisation/fetchOrganisationNumberStatistics',
      resetConversationList: 'chat/resetConversationList',
      clearStatisticLocalData: 'organisation/clearStatisticLocalData',
      setFolder: 'chat/setFolder',
      setUnreadCounter: 'organisation/setUnreadCounter',
      // resetPusher: 'pusher/resetPusher',
    }),
    // test() {
    //   console.log('test');
    //   this.resetPusher();
    // },
    saveToLocalstorage(key, value) {
      if (value) {
        localStorage.setItem(key, value);
      } else {
        // localStorage.removeItem(key);
      }
    },
    openAddMemberModal() {
      this.$refs.inviteTeamMemberModalRef.show();
    },
    openAddNumberModal() {
      this.$refs.addNumberModal.show();
    },
    resetIfNeeded() {
      this.resetConversationList(true);
    },
    startNewConversation() {
      if (this.$refs.newMessagePopover) {
        this.$refs.newMessagePopover.$emit('close');
      }
      if (this.filterBranchPopoverVisible) {
        this.$refs.branchFilterPopover.$emit('close');
        return;
      }
      if (this.currentOrganisation.businesses.length === 1) {
        this.startNewConversationForBranch(this.currentOrganisation.businesses[0]);
      } else if (!['OrganisationConversation', 'OrganisationWithId'].includes(this.$route.name) && this.$route.params.businessId) {
        this.startNewConversationForBranch(this.currentOrganisation.businesses.find(business => business.id === this.$route.params.businessId));
      } else if (this.currentOrganisation.businesses.length > 1) {
        this.$refs.branchFilterPopover.$emit('open');
      }
    },
    startNewConversationForBranch(branch) {
      this.$refs.branchFilterPopover.$emit('close');
      this.setFolder('open');
      this.newConversationTargetBranch = branch;
      this.$router
        .push({
          name: 'OrganisationBusiness',
          params: {
            organisationId: this.currentOrganisation.id,
            businessId: this.newConversationTargetBranch.id,
          },
        })
        .catch(() => {})
        .finally(() => {
          this.$eventBus.$emit('show-contact-search-view', this.newConversationTargetBranch);
        });
    },
    startBranchSelect() {
      this.filterBranchPopoverVisible = true;
      if (this.$refs.newMessagePopover) {
        this.$refs.newMessagePopover.$emit('disable');
      }
    },
    endBranchSelect() {
      this.filterBranchPopoverVisible = false;
    },
    closePopover() {
      this.$refs.branchFilterPopover.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
#organisation-panel {
  width: 258px;
  display: flex;
  flex-direction: column;
  //background-color: $greyUltralight;
  background-color: #f7fafc;
  // box-shadow: 1px 0 $greyBorderSecondary;
  // z-index: 999;
  border-right: 1px solid #e6ebed;

  #new-message {
    margin: 10px 10px 6px !important;
    padding: 7px 12px 5px !important;
    border-radius: 6px !important;
    box-shadow: 0 0 3px 0 rgba(48, 54, 70, 0.1) !important;
    border: solid 1px #e0e3e5 !important;
    background-color: #fdfefe !important;

    &:hover {
      box-shadow: 0 0 3px 0 rgba(48, 54, 70, 0.2) !important;
    }

    p {
      margin-left: 19px;
    }
  }

  .item-wrapper {
    margin: 8px 6px 8px 8px;
  }
}
.groups-wrap {
  margin-top: 10px;
  // TODO fix organisation panel scroll
  // overflow: auto;
  // height: calc(100% - 70px);
}

.group {
  // to get 30px between icon/text in different groups, top/bottom padding is 7px
  // (icon-itemBorder is 6px, item-item adds 4px, 14px are missing -> 14px/2 = 7px)
  padding: 16px 10px 7px;

  .indent a {
    padding-left: 36px;
  }
}

.count-unread {
  padding: 1px 6px 1px 6px;
  border-radius: 8px;
  background-color: $redPrimary;
  font-size: 11px;
  font-weight: 500;
  color: $white;
  height: 16px;
}

.panel-item {
  height: 28px;
  margin-bottom: 8px;
  font-family: HelveticaNeue, sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: left;
  color: $blackPrimary;
  border-radius: 6px;
  text-decoration: none;

  /* align content */
  display: flex;
  align-items: center;

  &.header {
    color: $blackUltralight;
  }

  .icon-wrap {
    margin-left: 4px;
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .title {
    padding-left: 11px;
  }

  .custom-icon {
    display: inline-block;
    background-repeat: no-repeat;
    background-position: center;
    height: 16px;
    width: 16px;

    &.panel-flows {
      background-image: url('~@/assets/img/SB-Icons/AI-stars.svg');
      // filter: grayscale(1);
    }
    &.panel-contacts {
      background-image: url('~@/assets/img/SB-Icons/panel-contacts.svg');
    }
    &.panel-conversations {
      background-image: url('~@/assets/img/SB-Icons/panel-conversations.svg');
    }
    &.panel-settings {
      background-image: url('~@/assets/img/SB-Icons/panel-settings.svg');
    }
    &.panel-analytics {
      background-image: url('~@/assets/img/SB-Icons/panel-analytics.svg');
    }
  }

  &.router-link-exact-active, &.router-link-active, &:hover {
    .custom-icon {
      &.panel-flows {
        filter: grayscale(0);
      }
    }
  }
}

.banner-app-btn .icon-wrap {
  display: inline-block;
  background-repeat: no-repeat;
  background-position: center;
  height: 16px;
  width: 16px;

  .custom-icon {
    display: inline-block;
    background-repeat: no-repeat;
    background-position: center;
    height: 16px;
    width: 16px;
    background-image: url('~@/assets/img/SB-Icons/add-team.svg');

    &.panel-flows {
      background-image: url('~@/assets/img/SB-Icons/AI-stars.svg');
    }
  }
}

// links
a.panel-item {
  &:hover {
    background-color: #eef0f2;
    text-decoration: none;
  }
  // highlight EXACT route match
  &.router-link-active:not(.only-exact):not(.hide-active),
  &.router-link-exact-active.only-exact:not(.hide-active),
  &.forced-match {
    background-color: $linkActive;
  }
}

.add-team-section {
  height: 28px;
  margin-bottom: 8px;
  font-family: HelveticaNeue, sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: normal;
  text-align: left;
  color: $bluePrimary;
  border-radius: 5px;
  /* align content */
  display: flex;
  align-items: center;

  .icon-wrap {
    width: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 4px;

    .custom-icon {
      display: inline-block;
      background-repeat: no-repeat;
      background-position: center;
      height: 16px;
      width: 16px;
      background-image: url('~@/assets/img/SB-Icons/add-team.svg');
    }
  }

  .title {
    padding-left: 11px;
  }

  &:hover {
    cursor: pointer;
    background: #e5e9eb;
    color: $blackPrimary;

    .icon-wrap {
      .custom-icon {
        background-image: url('~@/assets/img/SB-Icons/add-team-hover.svg');
      }
    }
  }
}

a:hover {
  text-decoration: none !important;
}

.top-layer {
  z-index: 9999999999;
  background: #e6e7e8;
  border-radius: 50px;

  &:hover, &.active {
    background: $white;
  }

  .user-avatar {
    margin-left: 0 !important;
  }
}

#download-desktop-app-btn, .banner-app-btn {
  min-height: 54px;
  border-top: solid 1px #e6ebed;
  cursor: pointer;
  background-color: $white;
  background-image: linear-gradient(92deg, #fffff4, #fff7fd 31%, #f7ffff 67%, #fafffa 100%);

  &.enable-flows {
    background-image: linear-gradient(101deg, #f5f7ff, #fdf7f9 49%, #f5fdff 100%);
  }

  * {
    font-size: 14px;
    font-weight: 500;
    color: $blackLight;
  }

  ::v-deep &:hover {
    * {
      color: $blackPrimary;
    }

    .sb-icon .icon.mask {
      background-color: $blackPrimary !important;
    }
  }
}
</style>

<style lang="scss">
// .to-desktop-handle {
//   display: none;
// }

.todesktop-platform-darwin {
//   .to-desktop-handle {
//     -webkit-app-region: drag;
//     display: flex;
//     justify-content: right;
//     height: 25px;
//     text-align: right;

//     .sb-icon {
//       margin-top: 3px;
//       cursor: pointer !important;
//     }
//   }

  #app:not(.full-screen) #organisation-panel {
    .to-desktop-handle {
      height: 30px;
      -webkit-app-region: drag;
    }
  }
}

// .browser-navigation button {
//   height: 26px;
//   width: 26px;
//   font-size: 13px;
//   background: #ddd;
//   cursor: pointer;
//   border: none;
//   border-radius: 50%;
//   line-height: 20px;
//   text-align: center;
//   outline: none;
// }

// .browser-navigation button:hover {
//   background: #ccc;
// }

</style>
